<!-- Backdrop shown behind the open drawer on mobile only (display:none on desktop) -->
<div class="sidebar-backdrop" *ngIf="!(isCollapsed$ | async)" (click)="closeSidebarOnMobile()"></div>

<aside [class.collapsed]="(isCollapsed$ | async)" class="sidebar">
    <!-- Logo Section -->
    <div class="logo-section" (click)="navigateToHome()">
      <!-- <img src="assets/images/vitalogo.png" alt="VitaGist" class="logo" />
      <span class="logo-text">Vita<span class="half-text">Gist</span></span> -->

      <!-- logotxt -->
      <div class="logo-with-badge notification-btn">
         <img class="logo" src="assets/images/lex-z_logo.png" alt="Lex-Z" class="logo"/>
      </div>
      <!-- logotxt -->

    </div>
  
    <!-- Navigation Links -->
    <nav class="nav-links">

      <a routerLink="/consumer/appointments" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Appointments')" [ngClass]="{ active: isappActive() }">
        <img src="assets/icons/calendari.png" alt="Calendar" class="nav-icon" />
        <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Appointments</span>
      </a>
      <a routerLink="/consumer/legal-information" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: false }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Legal Information')">
        <img src="assets/icons/legalinfo.png" alt="Legal Information" class="nav-icon" />
        <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Legal Information</span>
      </a>
      <!-- Connections with sub-menu -->
      <div class="nav-item-group">
        <a routerLink="/consumer/connections" [queryParams]="{ category: 'legal' }" class="nav-item"
          [class.collapsed]="(isCollapsed$ | async)" (click)="onConnectionsParentClick()"
          [ngClass]="{ active: isConnectionsActive() }">
          <img src="assets/icons/connectioni.png" alt="Connections" class="nav-icon" />
          <span class="nav-text" *ngIf="!(isCollapsed$ | async)">
            Connections
          </span>
          <!-- <span class="submenu-arrow" *ngIf="!(isCollapsed$ | async)" (click)="toggleConnectionsSubmenu($event)"
            [class.open]="connectionsSubmenuOpen">
            <i class="fas fa-chevron-down"></i>
          </span> -->
        </a>

        <div class="submenu" *ngIf="!(isCollapsed$ | async) && connectionsSubmenuOpen">
          <!-- <a routerLink="/connections" [queryParams]="{ category: 'personal' }"
            class="nav-item submenu-item"
            [ngClass]="{ active: isConnectionsCategoryActive('personal') }"
            (click)="onConnectionsCategoryClick('personal')">
            <i class="fas fa-user submenu-icon"></i>
            <span class="nav-text">Personal</span>
          </a> -->
          <!-- <a routerLink="/connections" [queryParams]="{ category: 'legal' }"
            class="nav-item submenu-item"
            [ngClass]="{ active: isConnectionsCategoryActive('legal') }"
            (click)="onConnectionsCategoryClick('legal')">
            <i class="fas fa-balance-scale submenu-icon"></i>
            <span class="nav-text">Legal & Finance</span>
          </a> -->
          <!-- <a routerLink="/connections" [queryParams]="{ category: 'others' }"
            class="nav-item submenu-item"
            [ngClass]="{ active: isConnectionsCategoryActive('others') }"
            (click)="onConnectionsCategoryClick('others')">
            <i class="fas fa-users submenu-icon"></i>
            <span class="nav-text">Others</span>
          </a> -->
        </div>
      </div>
      

      <a routerLink="/consumer/documents" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: false }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Documents')">
        <img src="assets/icons/docuemnti.png" alt="Documents" class="nav-icon" />
        <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Documents</span>
      </a>
      
      <a routerLink="/consumer/settings" class="nav-item" [ngClass]="{ active: isSettingsActive() }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Settings')">
        <img src="assets/icons/profilei.png" alt="Settings" class="nav-icon" />
        <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Profile Info</span>
      </a>

      <!-- Notifications with sub-menu -->
      <div class="nav-item-group">
        <a routerLink="/consumer/notifications" [queryParams]="{ tab: 'primary' }" class="nav-item"
          [class.collapsed]="(isCollapsed$ | async)" (click)="onNotifParentClick()"
          [ngClass]="{ active: isNotificationsActive() }">
          <img src="assets/icons/notificationi.png" alt="Notifications" class="nav-icon" />
          <span class="nav-text" *ngIf="!(isCollapsed$ | async)">
            Notifications
            <span class="notification-badge" *ngIf="notificationCount > 0">
              {{ notificationCount }}
            </span>
          </span>
          <span class="submenu-arrow" *ngIf="!(isCollapsed$ | async)" (click)="toggleNotifSubmenu($event)"
            [class.open]="notifSubmenuOpen">
            <i class="fas fa-chevron-down"></i>
          </span>
        </a>

        <!-- Sub-menu -->
        <div class="submenu" *ngIf="!(isCollapsed$ | async) && notifSubmenuOpen">
          <a routerLink="/consumer/notifications" [queryParams]="{ tab: 'primary' }"
            class="nav-item submenu-item"
            [ngClass]="{ active: isNotifTabActive('primary') }"
            (click)="onNotifTabClick('primary')">
            <i class="fas fa-inbox submenu-icon"></i>
            <span class="nav-text">Primary</span>
          </a>
          <a routerLink="/consumer/notifications" [queryParams]="{ tab: 'promotional' }"
            class="nav-item submenu-item"
            [ngClass]="{ active: isNotifTabActive('promotional') }"
            (click)="onNotifTabClick('promotional')">
            <i class="fas fa-tag submenu-icon"></i>
            <span class="nav-text">Promotional Offers</span>
          </a>
        </div>
      </div>
            
      <a href="javascript:void(0)" class="nav-item" [class.collapsed]="(isCollapsed$ | async)" (click)="onLogout()">
          <img src="assets/icons/logouti.png" alt="Logout" class="nav-icon" />
          <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Logout</span>
      </a>


    <!-- <a routerLink="/dashboard" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Dashboard')">
      <img src="assets/icons/dashboard.png" alt="Dashboard" class="nav-icon" />
      <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Dashboard</span>
    </a>

    <a routerLink="/health" routerLinkActive="active" class="nav-item" 
      [class.collapsed]="(isCollapsed$ | async)" [ngClass]="{ active: isHealthActive() }" (click)="onOptionClick('Health')">
      <img src="assets/icons/healthi.png" alt="Health" class="nav-icon" />
      <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Health</span>
    </a>

    <a routerLink="/documents" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: false }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Documents')">
      <img src="assets/icons/docuemnti.png" alt="Documents" class="nav-icon" />
      <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Documents</span>
    </a>

    <a routerLink="/connections" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Connections')">
      <img src="assets/icons/connectioni.png" alt="Connections" class="nav-icon" />
      <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Connections</span>
    </a>
    
    <a routerLink="/appointments" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Calendar')">
      <img src="assets/icons/calendari.png" alt="Calendar" class="nav-icon" />
      <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Calendar</span>
    </a>

    <a routerLink="/chats" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Chats')">
      <img src="assets/icons/chati.png" alt="Chats" class="nav-icon" />
      <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Chats</span>
    </a>

    <a routerLink="/notifications" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Notifications')">
      <img src="assets/icons/notificationi.png" alt="Notifications" class="nav-icon" />
      <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Notifications

      <button class="notification-btn" (click)="toggleNotifications()">
        <span class="notification-badge" *ngIf="notificationCount > 0">
          {{ notificationCount }}
        </span>
      </button>

      </span>
    </a>

    <a routerLink="/audittrails" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('AuditTrails')">
      <img src="assets/icons/audittrailsi.png" alt="AuditTrails" class="nav-icon" />
      <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Audit Trails</span>
    </a>

     <a routerLink="/settings" class="nav-item" [ngClass]="{ active: isSettingsActive() }"
          [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Settings')">
          <img src="assets/icons/settingsi.png" alt="Settings" class="nav-icon" />
          <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Settings</span>
     </a>
      
      <a routerLink="" class="nav-item" [class.collapsed]="(isCollapsed$ | async)" (click)="onLogout()">
          <img src="assets/icons/logouti.png" alt="Logout" class="nav-icon" />
          <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Logout</span>
      </a> -->
    
    </nav>
  </aside>